<template>
    <div class="templete">
        <div class="search_box search_box_f no_print clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" type="date" placeholder="开始日期" size="mini"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
                <el-date-picker v-model="end_time" type="date" placeholder="结束日期" size="mini"></el-date-picker>
            </div>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.original_length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.original_thickness" multiple collapse-tags placeholder="直径" @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.batch_no" placeholder="批次号"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.ship_no" placeholder="船名"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" filterable @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.status" placeholder="资源状态">
                <!-- <el-option :value="999" label="全部检尺状态"></el-option> -->
                <el-option :value="1" label="在途"></el-option>
                <el-option :value="2" label="现货"></el-option>
                <el-option :value="3" label="已售"></el-option>
                <!-- <el-option :value="4" label="已加工"></el-option> -->
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
            <!-- <div class="search_time search_inputBox">
                <el-date-picker v-model="end_time" type="date" placeholder="到港日期" size="mini"></el-date-picker>
            </div> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill" v-if="module.indexOf(',warehouse-statistic-export,')!=-1"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList no_print clearfix">
            <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-statistic-checkruler,')!=-1" @click="chi">检尺</el-button>
            <!-- <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-statistic-proportion,')!=-1" @click="batchPerEdit">修改百分比</el-button> -->
            <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-statistic-label,')!=-1" @click="printTip">标签</el-button>
            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',warehouse-statistic-edit,')!=-1" @click="batchEdit">批量修改</el-button>
            <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-statistic-delete,')!=-1" @click="batchDel">批量删除</el-button>
            <div class="execlInsertBtn" v-if="module.indexOf(',warehouse-import,')!=-1" @click="importDialogVisible=!importDialogVisible">
                <span class="excel_btn"><i class="excel-icon"></i>期初导入</span>
            </div>
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" scene="stock.wood.statistic"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @dialogViewClick="dialogViewClick" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalNumber" v-if="totalObj.original_cube||Number(totalObj.original_cube)==0">码单立方:{{totalObj.original_cube}}</div>
            <div class="totalNumber" v-if="totalObj.sales_cube||Number(totalObj.sales_cube)==0">库存立方:{{totalObj.sales_cube}}</div>
            <div class="totalNumber" v-if="totalObj.purchase_amount||Number(totalObj.purchase_amount)==0">码单金额:{{totalObj.purchase_amount}}</div>
            <div class="totalNumber" v-if="totalObj.sales_price||Number(totalObj.sales_price)==0">库存金额:{{totalObj.sales_price}}</div>
            <div class="totalNumber" v-if="totalObj.cost||Number(totalObj.cost)==0">成本金额:{{totalObj.cost}}</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 修改库存START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogA" width="630px" :modal="false" title="修正原始码单数据" custom-class="full_dialog">
            <el-form ref="editForm" :model="editForm" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  label="入库日期：" prop="inbound_time">
                        <el-date-picker v-model="editForm.inbound_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id">
                        <el-select v-model="editForm.supplier_id" @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="树种：" prop="breed_id">
                        <el-select v-model="editForm.breed_id" @visible-change="getSelectList('breed')">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="根号：" prop="bale_no">
                        <el-input v-model="editForm.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="批次号：" prop="batch_no">
                        <el-input v-model="editForm.batch_no"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="品牌：" prop="brand_id">
                        <el-select v-model="editForm.brand_id" @visible-change="getSelectList('brand')">
                            <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item  label="长度：" prop="original_length">
                        <el-input v-model="editForm.original_length"></el-input>
                    </el-form-item>
                    <el-form-item  label="船名：">
                        <el-input v-model="editForm.ship_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="直径：" prop="original_thickness">
                        <el-input v-model="editForm.original_thickness"></el-input>
                    </el-form-item>
                    <el-form-item  label="堆号：" prop="heap_no">
                        <el-input v-model="editForm.heap_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="立方：" prop="original_cube">
                        <el-input v-model="editForm.original_cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="外币单价：" prop="foreign_currency_price">
                        <el-input v-model="editForm.foreign_currency_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售单价：" prop="sales_price">
                        <el-input v-model="editForm.sales_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="采购单价：" prop="cube_price">
                        <el-input v-model="editForm.cube_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="仓库：" prop="warehouse_id">
                        <el-select v-model="editForm.warehouse_id" @visible-change="getSelectList('warehouse')">
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="editForm.remark"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="层数：" v-if="boardAfricaType">
                        <el-input v-model="editForm.layer_number"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item  label="等级：" prop="grade_id">
                        <el-select v-model="editForm.grade_id" @visible-change="getSelectList('grade')">
                            <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item  label="采购成本单价：" prop="purchase_amount">
                        <el-input v-model="editForm.purchase_amount"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item  label="产地：" prop="place_origin">
                        <el-input v-model="editForm.place_origin"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-input v-model="editForm.bill_lading_no"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item  label="目的港：" prop="port_id">
                        <el-select v-model="editForm.port_id" @visible-change="getSelectList('port')">
                            <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item  label="货柜号：" prop="container_no">
                        <el-input v-model="editForm.container_no"></el-input>
                    </el-form-item> -->
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="edit([editForm.id])">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改库存END -->
        <!-- 修改百分比START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisiblePer" class="eldialog eldialogOneLabel" width="400px" :modal="false" title="修改百分比" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item label="修改立方百分比:">
                        <el-input class="edit_input" v-model="perData.cube" placeholder=""></el-input>
                    </el-form-item>
                    <div style="font-size:12px;color:#777;margin-bottom:20px;float:left;width:100%;text-align:left;">注:值为0时，恢复为原码单方数</div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="PerEdit">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisiblePer = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改百分比END -->
        <!-- 检尺START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleChi" class="eldialog eldialogLine" width="500px" :modal="false" title="原木检尺" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item label="长度:">
                        <el-input class="edit_input" v-model="chiData.length" readonly placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="检尺长度:">
                        <el-input class="edit_input" v-model="chiData.check_length" placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="直径:">
                        <el-input class="edit_input" v-model="chiData.diameter" readonly placeholder=""></el-input>
                    </el-form-item>
                        <el-form-item label="检尺直径:">
                        <el-input class="edit_input" v-model="chiData.check_diameter" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <!-- <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit('reset')">保存并继续</el-button> -->
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="chiEdit">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleChi = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 检尺END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <!-- <div class="widthList">
                <div class="widthlistC clearfix">
                    <div class="widthInputC" v-for="(list,index) in widthObj.widthList" :Key="index">
                        <el-input class="widthInput" v-model="widthObj.widthList[index]"></el-input>
                    </div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="widthEdit">修改</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleWidth = false">取消</el-button>
            </div> -->
            <total-widthnew :edit="isCanWidthEdit" :isHidePer="isHidePer" :ispost="ispost" :dialogvisible="dialogVisibleWidth" :type="widthObj.widthType" :widthid="widthObj.id" :list="widthObj.widthList" @changeSuccess="getList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="期初导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='400px'>
            <!-- <div class="importExecl clearfix">
                <el-button v-if="boardAmericaType" :class="['funcPublicBtn',downLoadExeclType=='init_africa_stock'?'':'funcPublicBtnChecked']" @click="downLoadExeclType='init_america_stock'">板材</el-button>
                <el-button v-if="boardAfricaType" :class="['funcPublicBtn',downLoadExeclType=='init_africa_stock'?'funcPublicBtnChecked':'']" @click="downLoadExeclType='init_africa_stock'">非洲材</el-button>
            </div> -->
            <div class="text-center"  style="margin-top:20px;">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
                    <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                </el-upload>
                <div class="">
                    <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
        </el-dialog>
        <!--execl END-->
        <!-- 组装拆卸记录 dialog START -->
        <el-dialog v-dialog-drag :visible.sync="zuDialogVisible" class="eldialog eldialogC eldialogBack eldialogTransfer eldialogWidth" :modal="false" :title="'组装拆卸记录'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle">待出库</div>
                            <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.original_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本平摊单价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="船名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.ship_no }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="outAndInTitle">待入库</div>
                            <el-table :data="form_params.in.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.original_width_total }}
                                        </span>
                                        <!-- {{ scope.row.original_width_total }} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本平摊单价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="船名" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.ship_no }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="true"></textarea>
                    </div>
                </div>
                <div class="flex">
                    <div>单据日期：{{form_params.order_time}}</div>
                    <div>制单人：{{form_params.creator_name}}</div>
                </div>
            </div>
        </el-dialog>
        <!-- 组装拆卸记录 dialog END -->
        <!-- 退货记录dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleRecord" class="eldialog eldialogC threeLabel eldialogBack eldialogWidth" :modal="false" :title="'退货单记录'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="editPersonBox editPersonBoxTop clearfix">
                    <div class="editPerson">客户：{{form_params_record.customer_name}}</div>
                    <div class="editPerson">退货单号：{{form_params_record.order_return_sn}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="form_params_record.details" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                        <div class="sign" v-if="scope.row.new_inventory_id==new_inventory_id"></div>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="供应商" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.supplier }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.sales_width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库立方" prop="out_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',out_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.out_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货立方" prop="return_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',return_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="销售单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.sales_price }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退款金额(￥)" prop="return_amount" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',return_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.return_amount }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox remarkBoxT remarkBoxFourText">
                        <textarea class="remarkTextarea" readonly v-model="form_params_record.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params_record.creator_name}}</div>
                    <div class="editPerson">销售人：{{form_params_record.salesman_name}}</div>
                    <div class="editPerson">退货时间：{{form_params_record.create_time | dateFormat_}}</div>
                </div>
            </div>
        </el-dialog>
        <!-- 退货记录dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="stock.wood.statistic" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 标签打印 START -->
        <div class="print">
            <div class="printTipBox" v-for="(list,index) in printTipList" :key="index">
                <div :class="['tipNameBox',list.category_id==1?'tipNameBoxB':'']">
                    <div class="tipbale_no">{{list.bale_no}}</div>
                    <div class="tipName tipNameA" v-if="list.category_id==1">{{list.breed}}</div>
                    <div class="tipName tipNameB" v-if="list.category_id==2">{{list.thk}}</div>
                </div>
                <div :class="['mess','clearfix',list.category_id==1?'messB':'messC']">
                    <img :src="list.qr_code" class="tipImage"/>
                    <div class="tipDetail tipDetailA clearfix" v-if="list.category_id==1">
                        <div class="detail detailbeimei"><span class="detailContentT detailContentTP">THK:</span><span class="detailContent">{{list.thk}}</span></div>
                        <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Grade:</span><span class="detailContent">{{list.grade}}</span></div>
                        <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Length:</span><span class="detailContent">{{list.original_length}}</span></div>
                        <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Brand:</span><span class="detailContent">{{list.brand}}</span></div>
                        <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Contract No:</span><span class="detailContent">{{list.contract_no}}</span></div>
                    </div>
                    <div class="tipDetail tipDetailB clearfix" v-if="list.category_id==2">
                        <div class="detail"><span class="detailContentT">批次:</span><span class="detailContent">{{list.batch_no}}</span></div>
                        <div class="detail"><span class="detailContentT">品名:</span><span class="detailContent">{{list.breed}}</span></div>
                        <div class="detail"><span class="detailContentT">材积:</span><span class="detailContent">{{list.original_cube}}</span></div>
                        <div class="detail"><span class="detailContentT">层数:</span><span class="detailContent">{{list.layer_number}}</span></div>
                        <div class="detail"><span class="detailContentT">合同:</span><span class="detailContent">{{list.contract_no}}</span></div>
                    </div>
                </div>
                <!-- <div class="printBottomCB clearfix" v-if="list.category_id==1">
                    <div class="printBottom">
                        <div class="bottomMess">{{list.company_name}}</div>
                        <div class="bottomMess">公司地址：{{list.company_address}}</div>
                        <div class="bottomMess">联系电话：{{list.company_mobile}}</div>
                    </div>
                </div> -->
                <div class="printBottomCF clearfix" v-if="list.category_id==2">
                    码单：{{list.width}}
                </div>
            </div>
        </div>
        <!-- 标签打印 END -->
    </div>
</template>
<style scoped lang="scss">
    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:32px;height:32px;float:left;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
    .importExecl{width:100%;text-align: center;}
    .importExecl .funcPublicBtn{display: inline;float: none;}
    .sign{width:15px;height:15px;background: url('/icon/lu.png') no-repeat 100% 100%;background-size: 100% 100%;float: right;position: relative;top:4px;}
    .eldialogBack.eldialogC .dialogFlow{max-height:490px;}
    .eldialogBack .remarkBox{width:1090px;}
    .eldialogBack .remarkBoxT{width:1090px;}

    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}

    //标签打印 START
    .print{color:#000;}
    .print .printTipBox{background-color: #fff;position: relative;display: inline-block;width:14.25cm;height:9.5cm;border-bottom:1px dotted #ccc;}
    .print .tipNameBox{text-align: center;padding-bottom:5px;}
    .print .tipNameBoxB{border-bottom:2px solid #000;}
    .print .tipbale_no{font-size: 75px;font-weight: 600;font-family: fantasy;}
    .print .tipNameA{font-size: 30px;font-weight: 600;}
    .print .tipNameB{font-size: 45px;font-weight: 600;}
    .print .printTipBox .mess{position: relative;padding:8px 0;padding-right:180px;box-sizing: border-box;}
    .print .printTipBox .messB{border-bottom:2px solid #000;padding:0px 0;padding-right:180px;}
    .print .printTipBox .messC{padding:0px 0;padding-right:180px;margin-top:10px;}
    .print .tipImage{width:155px;height:155px;position: absolute;top:0px;right:10px;bottom:0;margin:auto;}
    /* .print .tipDetail{} */
    .print .detail{min-width: 40%; height:41px;text-align: left;font-size: 28px;margin-bottom:10px;padding-left:10px;box-sizing: border-box;margin-right:35px;}
    .print .detail:nth-child(2n){margin-right: 0;}
    .print .detail .detailContent{font-weight: 600;}
    .print .tipDetailA .detail{margin-bottom:25px;float: left;}
    .print .tipDetailB .detail{float:left;}
    .print .tipDetailB .detailA{width:100%;}
    .print .tipDetail .detail:last-child{margin-bottom:0;}
    .printBottomCB{text-align: right;padding:0 10px;margin-top:5px;}
    .printBottomCB .printBottom{display: inline-block;text-align: left;}
    .printBottomCB .bottomMess{font-size: 12px;padding:1px 0;}
    .printBottomCF{padding:0 10px;margin-top:5px;font-size: 12px;text-align: left;}
    .detailContentT{font-size: 12px;}
    .print .detailbeimei{height: 35px!important;position: relative;padding-left:50px;box-sizing: border-box;}
    .print .detailContentTP{position: absolute;width:50px;text-align: right;top:50%;transform: rotateY(-50%);left:0;}
    //标签打印 END
    .flex{display: flex;}
    .flex div{padding-right: 20px}
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                importDialogVisible:false,
                dialogVisibleRecord:false,
                billColumn:"",
                ispost:true,
                isHidePer:false,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    breed_id:"",
                    original_length:"",
                    original_thickness:"",
                    contract_no:"",
                    bill_lading_no:"",
                    batch_no:"",
                    ship_no:"",
                    supplier_id:"",
                    warehouse_id:"",
                    status:"",
                    remark:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                categoryList:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[]
                },
                form_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:""
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                pieces:"",
                                original_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:""
                            }
                        ]
                    },
                    remark:""
                },
                form_params_record:{},
                list:[],
                tableCol:[	
                    {colName:"资源状态",colKey:"status_str",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isDialogView:true},
                    {colName:"入库日期",colKey:"inbound_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"到日期",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"根号",colKey:"bale_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺长度",colKey:"check_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"直径",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺直径",colKey:"check_diameter",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"检尺立方",colKey:"check_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"立方差",colKey:"cube_sub",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用平摊单价",colKey:"cost",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库时间",colKey:"code",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                perData:{
                    id:[],
                    cube:""
                },
                dialogVisible:false,
                dialogVisiblePer:false,
                dialogVisibleChi:false,
                dialogVisibleWidth:false,
                zuDialogVisible:false,
                isCanWidthEdit:false,
                widthObj:{
                    id:"",
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                editForm:{
                    id:[],
                    inbound_time:"",
                    supplier_id:"",
                    breed_id:"",
                    contract_no:"",
                    bale_no:"",
                    batch_no:"",
                    original_length:"",
                    ship_no:"",
                    original_thickness:"",
                    heap_no:"",
                    original_cube:"",
                    foreign_currency_price:"",
                    sales_price:"",
                    cube_price:"",
                    warehouse_id:"",
                    remark:""
                },
                chiData:{
                    id:"",
                    length:"",
                    diameter:"",
                    check_length:"",
                    check_diameter:"",
                },
                printTipList:[],
                totalObj:{},
                perIds:[],
                perType:2,//修改百分比  2单个修改 3多个修改
                editIds:[],
                editType:2,//修改  2单个修改 3多个修改
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                downLoadExeclType:"init_wood_stock",
                filterDialogVisible:false,
                filter:"",
                fields:"",
                new_inventory_id:"",
                selectCube:0.0000
            }
        },
        created(){
            this.getSelectList("brand")
            this.getSelectList("breed")
            this.getSelectList("port")
            this.getSelectList("grade")
            this.getSelectList("warehouse")
            this.getSelectList("supplier")
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.downLoadExeclType = "init_wood_stock";
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/stock.wood.statistic.export","原木库存管理",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getBillColumn(scene){
                this.postFunc("/erp/company.column.data",{scene:scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //打印标签
            printTip(){
                if(this.selectRow.length<1){
                    this.tip("请选择打印数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.postFunc("/erp/inventory.print.tag",{id:arr},res=>{
                        this.pl(res);
                        this.printTipList=res.data.data;
                        setTimeout(() => {
                            window.print();
                        }, 0);
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            //查看组装拆卸
            dialogViewClick(row){
                if(row.type=="ad_id"){
                    this.getBillColumn("assembly.create.column")
                    this.postFunc("/erp/assembly.view",{id:row.row.ad_id},res=>{
                        this.form_params.out.detail=res.data.data.out;
                        this.form_params.in.detail=res.data.data.in;
                        this.form_params.remark=res.data.data.info.remark;
                        this.form_params.order_time = this.formatTime(res.data.data.info.order_time+"000");
                        this.form_params.creator_name = res.data.data.info.creator_name;
                        this.zuDialogVisible=true;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(row.type=="return_id"){
                    this.getBillColumn("return.details")
                    this.postFunc("/erp/inventory.return.view",{id:row.row.id,return_id:row.row.return_id},res=>{
                        this.form_params_record=res.data.data;
                        this.form_params_record.details.forEach((item,index) => {
                            this.form_params_record.details[index].return_cube=this.keepLimit(this.form_params_record.details[index].return_cube)
                            this.form_params_record.details[index].sales_cube=this.keepLimit(this.form_params_record.details[index].sales_cube)
                            this.form_params_record.details[index].out_cube=this.keepLimit(this.form_params_record.details[index].out_cube)
                            this.form_params_record.details[index].sales_price=this.keepPrice(this.form_params_record.details[index].sales_price)
                            this.form_params_record.details[index].totalPrice=this.keepPrice(Number(this.form_params_record.details[index].sales_price)*Number(this.form_params_record.details[index].sales_cube))
                        });
                        this.dialogVisibleRecord=true;
                        this.new_inventory_id = row.row.id;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,1).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            addWidth(){
                this.widthObj.widthList.push(null)
            },
            delWidth(ind){
                 this.widthObj.widthList.forEach((item,index)=>{
                    if(index==ind){
                        this.widthObj.widthList.splice(index,1)
                    }
                 })
            },
            widthEdit(){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFunc("/erp/inventory.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleWidth=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //检尺修改START
            chiEdit(type){
                this.postFuncLoading("/erp/stock.wood.check",this.chiData,()=>{
                    if(type=="reset"){
                        this.chiData=this.resetJson(this.chiData)
                    }else{
                        this.dialogVisibleChi=false;
                    }
                    this.tip('检尺成功','success');
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            chi(){
                if(this.selectRow.length>1){
                    this.tip("请选择一件库存商品检尺","warning")
                    return;
                }else if(this.selectRow.length==1&&this.selectRow[0].status==5){
                    this.tip("已售资源无法检尺","warning")
                    return;
                }else if(this.selectRow.length==1&&this.selectRow[0].status==-1&&this.selectRow[0].delete_time==0){
                    this.tip("已加工资源无法检尺","warning")
                    return;
                }else{
                    if(this.selectRow.length<1){
                        this.dialogVisibleChi=!this.dialogVisibleChi;
                    }else{
                        if(!this.selectRow[0].isCheck){
                            this.tip("选择商品不可检尺","warning")
                            return;
                        }else{
                            // let arr = new Array();
                            // arr[0] = this.selectRow[0].id;
                            // this.chiData.id=arr;
                            // this.chiData.bale_no = this.selectRow[0].bale_no;
                            // this.chiData.original_cube = this.selectRow[0].original_cube;
                            // this.chiData.check_cube = this.selectRow[0].check_cube;
                            // this.chiData.sales_cube = this.selectRow[0].sales_cube;
                            this.chiData.id = this.selectRow[0].id;
                            this.chiData.length = this.selectRow[0].original_length;
                            this.chiData.diameter = this.selectRow[0].original_thickness;
                            this.chiData.check_length = this.selectRow[0].check_length;
                            this.chiData.check_diameter = this.selectRow[0].check_diameter;
                            this.dialogVisibleChi=!this.dialogVisibleChi;
                        }
                    }
                }
            },
            //检尺修改END
            //百分比修改START
            batchPerEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存商品","warning")
                }else{
                    let flag = true;
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].status==5){
                            this.tip("已售资源无法百分比修改","warning")
                            this.flag=false;
                            return;
                        }
                        if(!this.selectRow[i].isPercentage){
                            flag = false;
                            this.tip("选择商品中有不可修改项","warning")
                            return;
                        }else{
                            this.perIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.perType=3;
                        this.dialogVisiblePer=true;
                    }   
                }
            },
            PerEdit(){
                if(this.perType==3){
                    this.perData.id=this.perIds;
                }
                this.postFuncLoading("/erp/inventory.proportion",this.perData,()=>{
                    this.tip('百分比修改成功','success');
                    this.dialogVisiblePer=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //百分比修改END
            //修改库存START
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].status==5){
                            this.tip("已售资源无法修改","warning")
                            this.flag=false;
                            return;
                        }
                        if(!this.selectRow[i].isEdit){
                            flag = false;
                            this.tip("选择商品中有不可修改项","warning")
                            return;
                        }else{
                            this.editIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.editType=3;
                        this.dialogVisible=true;
                    }   
                }
            },
            edit(){
                if(this.editType==3){
                    this.editForm.id=this.editIds;
                }
                let url = "";
                if(this.editType==2){
                    url = "/erp/stock.wood.update.one";
                }else{
                    url = "/erp/stock.wood.update";
                }
                let time = this.editForm.inbound_time;
                this.editForm.inbound_time=this.formatTimeZero(this.editForm.inbound_time)
                this.postFuncLoading(url,this.editForm,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisible=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.editForm.inbound_time = time;
                },()=>{
                    this.editForm.inbound_time = time;
                })
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.editForm=JSON.parse(JSON.stringify(item));
                        this.editForm = this.clearZero(this.editForm)
                        // let arr = new Array();
                        // arr[0]=item.id;
                        this.editForm.id=item.id;
                    }
                })
                this.dialogVisible=true;
            },
            //修改库存END
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].status==5){
                            this.tip("已售资源无法删除","warning")
                            this.flag=false;
                            return;
                        }
                        if(!this.selectRow[i].isDelete){
                            flag = false;
                            this.tip("选择商品中有不可删除项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.del(arr)
                    }
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/inventory.delete",{id:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            reset(){
                this.start_time=null;
                this.end_time=null;
                this.params=this.resetSearch(this.params)
                this.params.check_status=999;
                this.params.status=2;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = this.start_time;
                this.params.end_time = this.end_time;
                this.params.start_time=this.formatTimeZero(this.params.start_time);
                this.params.end_time=this.formatTimeZero(this.params.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/stock.wood.statistic",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj=res.data.data.total;
                    this.totalObj.original_cube=this.keepLimit(this.totalObj.original_cube)
                    this.totalObj.sales_cube=this.keepLimit(this.totalObj.sales_cube)
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[index].inbound_time ='';
                        }
                        if(item.expiry_time){
                            this.list[index].expiry_time = this.formatTime(this.list[index].expiry_time+"000")
                        }else{
                            this.list[index].expiry_time = "";
                        }
                        // this.list[index].plate_ruler = this.keepLimit(item.plate_ruler)
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                        // this.list[index].original_width_total = parseInt(item.original_width_total)
                        // this.list[index].sales_width_total = parseInt(item.sales_width_total)
                        if(item.ad_id!=0){
                            if(item.ad_type==1){
                                item.isDialogViewAdIdHe=true;
                            }
                            if(item.ad_type==2){
                                item.isDialogViewAdIdChai=true;
                            }
                        }
                        if(item.return_id!=0){
                            item.isDialogViewReturnId=true;
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_str"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                this.dialogVisibleWidth=true;
                this.list.forEach(item=>{
                    if(item.id==obj.id){
                        this.widthObj.id=item.id;
                        if(obj.name=="original_width_total"){
                            this.widthObj.widthType=2;
                            this.widthObj.widthList=item.width;
                            this.isHidePer = true;
                        }else{
                            this.widthObj.widthType=3;
                            this.widthObj.widthList=item.sales_width;
                            this.isHidePer = false;
                        }
                        item.isEdit?this.isCanWidthEdit = true:this.isCanWidthEdit = false;
                    }
                })
            },
            getTableDelete(id){
                this.del([id])
            },
            
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },

            //期初导入
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                let url = "/erp/import.init.wood";
                this.analysis(url,this.file_url,"","","",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            downTemplete(){
                this.exportFile(this.downLoadExeclType,"","","",response=>{
                    let title = "原木";
					const content = response.data;
					const blob = new Blob([content], {type: response.headers['content-type']});
					const fileName = title+'期初导入'+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                }).catch((e) => {});
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.editForm=this.resetJson(this.editForm);
                    this.editIds=[];
                    this.editType=2
                }
            },
            "dialogVisiblePer":function(val){
                if(!val){
                    this.perData=this.resetJson(this.perData);
                    this.perData.id=[];
                }
            },
            "dialogVisibleChi":function(val){
                if(!val){
                    this.chiData=this.resetJson(this.chiData)
                }
            },
            "dialogVisibleWidth":function(val){
                if(!val){
                    this.widthObj={id:"",widthList:[],widthType:2}
                }
            }
        }
    }
</script>
